export default __webpack_public_path__ + "static/media/buy_transfer_eth.fd9264bc.svg";